"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.USER_ROUTES = void 0;
// Keep route prefixes independent of permission checks so infrastructure can use them.
exports.USER_ROUTES = {
    ALERTS: '/alerts',
    ANALYTICS: '/analytics',
    ORDERS: '/orders',
    LONGHAUL: '/longhaul-orders',
    REPORTING: '/reporting',
    SETTINGS: '/settings',
    SHIPMENTS: '/shipments',
    RETAILER: '/retailer',
    PRODUCTS: '/products',
    PROFILE: '/profile',
    INFORMATION: '/information',
    NOTIFICATIONS: '/notifications',
    CARRIER: '/carrier',
    FACILITY_ORDERS: '/facility-orders'
};
